import { render, staticRenderFns } from "./ListPanelChannel.vue?vue&type=template&id=239b6562&scoped=true&"
import script from "./ListPanelChannel.vue?vue&type=script&lang=js&"
export * from "./ListPanelChannel.vue?vue&type=script&lang=js&"
import style0 from "./ListPanelChannel.vue?vue&type=style&index=0&id=239b6562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239b6562",
  null
  
)

export default component.exports